import React, { useState } from "react";
import { getDataFromConfig , checkIfTitleIsUnique} from "../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import "../configureKPICommon.css";

interface KPIConfigTitleChangeProps {
  kpi: Record<string, any>;
  updateUserConfig: (id: string, newKPI: any) => void;
  inputDataValidation: { minLength: number; maxLength: number };
  defaultConfigGlobal : Record<string,any>;
}
function capitalizeSentence(sentence:string) {
  return sentence
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
    .join(" "); 
}

const KPIConfigTitleChange: React.FC<KPIConfigTitleChangeProps> = ({
  kpi,
  updateUserConfig,
  inputDataValidation,
  defaultConfigGlobal
}) => {
  
  const fieldLabel = getDataFromConfig("KPI_title", kpi.id,defaultConfigGlobal);
  const usersSavedLabelValue = kpi.title;
  const [inputValue, setInputValue] = useState<string>(usersSavedLabelValue);
  const getErrorMessage = (input: string): string => {
    if (input.length < inputDataValidation.minLength) {
      return `Title must be at least ${inputDataValidation.minLength} characters.`;
    } 
    // else if (input.length > inputDataValidation.maxLength) {
    //   return `Title cannot exceed ${inputDataValidation.maxLength} characters.`;
    // } 
    else if(!checkIfTitleIsUnique(kpi,input)) 
    {
      return `Title must be unique.`; 
    }
    else {
      return "";
    }
  };
  const [errorMessage, setErrorMessage] = useState<string>(
    getErrorMessage(usersSavedLabelValue)
  );

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    // Validate the new value based on min and max title length
    if(newValue.length <= inputDataValidation.maxLength)
{
    setErrorMessage(getErrorMessage(newValue));
    setInputValue(newValue);
    const newKPI = { ...kpi, title: newValue.trim() };
    updateUserConfig(kpi.id, newKPI);}
  };

  return (
    <div className="kpi-label-container">
      <div className="kpi-label-title">Customize label for {capitalizeSentence(fieldLabel)}</div>
      <div className="kpi-input-wrapper">
        <h3 className="kpi-saved-label">{capitalizeSentence(fieldLabel)}</h3>
        <div className="kpi-input-box-and-error-container">
          <input
            className="kpi-input-box"
            type="text"
            value={capitalizeSentence(inputValue)}
            onChange={handleInputChange}
            placeholder="Enter KPI title"
          />
          {errorMessage && (
            <div className="kpi-error-message">{errorMessage}</div>
          )}{" "}
          {/* Display error message */}
        </div>
      </div>
    </div>
  );
};

export default KPIConfigTitleChange;
